import {
  Button,
  Col,
  Edit,
  Row,
  SaveButton,
  useForm,
} from "@pankod/refine-antd";
import { HttpError, IResourceComponentsProps, useNavigation } from "@pankod/refine-core";
import { useParams } from "@pankod/refine-react-router-v6";

import { FeatureFlagsForm } from "components/forms";
import {
  IFeatureFlag,
  IFeatureFlagEditPayload,
} from "interfaces/feature-flags";
import { FeatureFlagsHeaderBreadcrumb } from "./components/feature-flags-header-breadcrumb";
import {
  FEATURE_FLAGS_LIST_PATH,
  FEATURE_FLAGS_RESOURCE,
  FEATURE_FLAGS_TEXTS,
} from "./utils/feature-flags.constants";
import {
  buildFeatureFlagEditPayload,
  FeatureFlagPayloadFormValues,
} from "./utils/feature-flags.payload";

export const FeatureFlagsEdit: React.FC<IResourceComponentsProps> = () => {
  const { push } = useNavigation();
  const { id } = useParams();
  const { formProps, saveButtonProps, onFinish } = useForm<
    IFeatureFlag,
    HttpError,
    IFeatureFlagEditPayload
  >({
    action: "edit",
    resource: FEATURE_FLAGS_RESOURCE,
    id,
    redirect: false,
    successNotification: {
      type: "success",
      message: FEATURE_FLAGS_TEXTS.successTitle,
      description: FEATURE_FLAGS_TEXTS.successMessage,
    },
    onMutationSuccess: () => push(FEATURE_FLAGS_LIST_PATH),
  });

  const handleFinish = (values: FeatureFlagPayloadFormValues) => {
    return onFinish(buildFeatureFlagEditPayload(values));
  };

  return (
    <Edit
      title="Editar"
      saveButtonProps={saveButtonProps}
      breadcrumb={<FeatureFlagsHeaderBreadcrumb />}
      footerButtons={() => (
        <Row gutter={[6, 6]}>
          <Col>
            <Button
              onClick={() => push(FEATURE_FLAGS_LIST_PATH)}
              style={{ minWidth: "92px" }}
            >
              Cancelar
            </Button>
          </Col>
          <Col>
            <SaveButton
              {...saveButtonProps}
              icon={null}
              style={{ minWidth: "92px" }}
            >
              Incluir
            </SaveButton>
          </Col>
        </Row>
      )}
    >
      <FeatureFlagsForm
        formProps={{
          ...formProps,
          onFinish: handleFinish,
        }}
      />
    </Edit>
  );
};
